import React from "react";
// Components
import Navbar from "../../components/Navbar";
import Regional from "../../assets/navbar/Regional_on_light_blue.svg";
import { ImPlus } from "react-icons/im";
import * as S from "./styles";
import ListRegional from "../../components/ListRegional";
import { useHistory, useLocation } from "react-router-dom";

export default function RegionalList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={Regional} />
            <div>
              <S.Title>Regional</S.Title>
              <S.Description>Cadastro geral de regionais</S.Description>
            </div>
          </S.BoxUser>

          <S.AddNew onClick={() => history.push("/cadastro-regionais")}>
            <ImPlus
              style={{
                margin: "0px 0px 30px",
              }}
            />

            <S.Image src={Regional} />
          </S.AddNew>
        </S.Header>

        <ListRegional
          filter={params.get("filter") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
